import TooltipEllipsis from '@deltek/specification-client/core/Feedbacks/TooltipEllipsis'
import ContainerMaxWidthXl from '@deltek/specification-client/core/Surfaces/ContainerMaxWidthXl'
import AppBar from '@material-ui/core/AppBar'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    actionBar: {
        background: theme.palette.grey[700],
        minHeight: 60,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0, 0),
        },
    },
    h1Text: {
        ...theme.typography.h1,
        fontSize: 30,
        [theme.breakpoints.up('xs')]: {
            padding: theme.spacing(0, 3),
        },
    },
}))

export interface DefaultActionBarProps {
    pageTitle?: string
}

const DefaultActionBar: React.FC<DefaultActionBarProps> = ({
    pageTitle = '',
}) => {
    const classes = useStyles()

    return (
        <AppBar
            elevation={0}
            position="relative"
            className={clsx('appHeader', classes.actionBar)}
        >
            <ContainerMaxWidthXl>
                <TooltipEllipsis
                    lineLimit={2}
                    text={pageTitle}
                    className={classes.h1Text}
                >
                    <Typography variant="h1">{pageTitle}</Typography>
                </TooltipEllipsis>
            </ContainerMaxWidthXl>
        </AppBar>
    )
}

export default DefaultActionBar
